/**
 * EatOkra Tracking Core — loaded globally via application.html.haml.
 *
 * Owns the universal pieces:
 *   - track() helper that pushes to dataLayer (and to Amplitude via
 *     the window.clicked() bridge for any clicked() calls — handled
 *     separately in application.js).
 *   - Delegated click handler that turns [data-track-click] +
 *     [data-track-prop-*] markup into dataLayer events anywhere on
 *     the site.
 *
 * Does NOT own:
 *   - Page-load beacons (homepage_loaded, article_view, etc.) —
 *     each page does its own inline push.
 *   - Section impressions (homepage_section_view) — lives in
 *     eatokra_homepage_tracking.js, loaded only on the homepage.
 *   - Article read-depth and link classification — lives in
 *     eatokra_article_tracking.js, loaded only on /posts/show.
 *
 * GDPR: dataLayer pushes are always-on (matches the established
 * pattern). Amplitude is gated separately wherever it's called.
 */
(function () {
  'use strict';

  // Mark presence so other packs can detect duplicate-load.
  if (window.__eatokraTrackingCoreLoaded) return;
  window.__eatokraTrackingCoreLoaded = true;

  function track(eventName, props) {
    var payload = Object.assign(
      {
        event: eventName,
        page_path: location.pathname,
        page_url: location.href,
        timestamp: Date.now(),
      },
      props || {}
    );
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(payload);
    }
  }

  // Walk up to the nearest [data-track-section] ancestor for
  // attribution, if present.
  function closestSection(el) {
    while (el && el !== document.body) {
      if (el.getAttribute && el.getAttribute('data-track-section')) {
        return el.getAttribute('data-track-section');
      }
      el = el.parentNode;
    }
    return null;
  }

  function dataAttr(el, name, fallback) {
    if (!el) return fallback;
    var val = el.getAttribute('data-' + name);
    return val == null || val === '' ? fallback : val;
  }

  // Any data-track-prop-foo-bar="..." becomes property foo_bar.
  function customProps(el) {
    var props = {};
    if (!el || !el.attributes) return props;
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      var prefix = 'data-track-prop-';
      if (a.name.indexOf(prefix) === 0) {
        var key = a.name.slice(prefix.length).replace(/-/g, '_');
        props[key] = a.value;
      }
    }
    return props;
  }

  function initClickTracking() {
    document.addEventListener(
      'click',
      function (event) {
        var el = event.target;
        while (el && el !== document.body) {
          if (el.getAttribute && el.getAttribute('data-track-click')) {
            break;
          }
          el = el.parentNode;
        }
        if (!el || el === document.body) return;

        var eventName = el.getAttribute('data-track-click');
        var section = closestSection(el);
        var props = Object.assign(
          {
            section: section,
            element: dataAttr(el, 'track-element', null),
            position: parseInt(dataAttr(el, 'track-position', '0'), 10),
            destination_url: el.getAttribute('href') || null,
          },
          customProps(el)
        );
        track(eventName, props);
        // Never preventDefault — let the link/button work normally.
      },
      true
    );
  }

  // Expose for other packs to reuse if they want the same helpers.
  window.eatokraTrack = window.eatokraTrack || track;
  window.eatokraTrackInit = window.eatokraTrackInit || function () {};

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClickTracking);
  } else {
    initClickTracking();
  }
})();
